"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _reactSpinners = require("react-spinners");
require("./styles.scss");
/**
 * @typedef LoaderProps
 * @type {{
 *     loading: boolean;
 *     title?: React.ReactNode;
 * }}
 */

/** @param {LoaderProps} props */
var Loader = function Loader(_ref) {
  var loading = _ref.loading,
    title = _ref.title;
  if (!loading) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "Loader"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    color: "white",
    variant: "h6",
    my: 4
  }, /*#__PURE__*/_react["default"].createElement("strong", null, title)), /*#__PURE__*/_react["default"].createElement(_reactSpinners.PulseLoader, {
    color: "#00679d",
    loading: true,
    size: 30
  }));
};
var _default = Loader;
exports["default"] = _default;